import { render, staticRenderFns } from "./FrontpageRecent.vue?vue&type=template&id=1212635e&"
import script from "./FrontpageRecent.vue?vue&type=script&lang=js&"
export * from "./FrontpageRecent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports